import { colors, FelaCSS } from '@bridebook/ui';
import { IThemeProperties } from '@bridebook/web/lib/wedding-website/utils/get-theme-properties';

interface IStyles {
  wrapper: FelaCSS;
  innerWrapper: FelaCSS;
  contentWrapper: FelaCSS;
  mobileButtonRoot: FelaCSS;
}

const sharedWrapperStyles: (themeProperties: IThemeProperties, isPreview?: boolean) => IStyles = (
  themeProperties,
  isPreview = false,
) => ({
  wrapper: {
    color: colors.space,
    backgroundColor: themeProperties.paletteColors.backgroundAlt,
    backgroundImage: `url(${themeProperties.paletteExtraAsset})`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
    backgroundSize: '160%',
    flex: 1,
    ...(isPreview
      ? { height: '100%', overflowY: 'auto' as const }
      : { minHeight: '100vh', height: '100%' }),
    minWidthMobileLg: {
      backgroundSize: 'contain',
      ...(!isPreview && { minHeight: 'calc(100vh - 170px)' }),
    },
  },
  innerWrapper: {
    maxWidth: 620,
    ...(isPreview
      ? { flexGrow: 1, flexShrink: 0, minHeight: '100%' }
      : { flex: 1, height: '100%' }),
    minWidthMobileLg: {
      backgroundColor: 'rgba(77, 82, 227, 0.03)',
    },
  },
  contentWrapper: {
    flex: 1,
  },
  mobileButtonRoot: {
    position: 'sticky',
    bottom: 0,
  },
});

export default sharedWrapperStyles;
